import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormGroupControl } from '@components/Base';
import { Numeric } from '@utils/typescript';

type Props = {
  name: string;
  label: string;
  age: Numeric | '';
  isVisible: boolean;
};

const MemberAnswerItem = ({ name, label, age, isVisible }: Props) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <FormGroupControl
      name={name}
      label={`${label} (${t('user.yearsOld', { age: age })}), ${t('common:specifyProblem')}`}
      placeholder={t('common:enterDetail')}
      groupProps={{ className: 'my-3' }}
    />
  );
};

export { MemberAnswerItem }
